import { getDefaultParameters } from "@/utils";
import { PaymentBookingServerProps, PaymentFormInputProps } from "@domains/payment/paymentForm";
import { PaidRooms } from "@shared/server";

export const datasToPaymentServerData = (data: PaymentFormInputProps, selectRoomList: PaidRooms[]) => {
    let paymentServerDataArray: PaymentBookingServerProps | Array<PaymentBookingServerProps> = [];
    const defaultParams = getDefaultParameters();
    if (data.payMethod !== "account") {
        selectRoomList.forEach((room) => {
            const paymentServerData: PaymentBookingServerProps = {
                co_id: defaultParams.co_id,
                idx: Number(defaultParams.idx),
                room_num: Number(room.roomIdx),
                or_name: data.buyer,
                checkin: room.date.split("(")[0],
                period: room.dayNight,
                tel: data.phoneNumber,
                adult: Number(room.roomDetailInfo.personOfCapacity.min) + Number(room.addPeople.adult),
                children: Number(room.addPeople.child) + Number(room.addPeople.infant),
                pay_basic: room.discountPrice,
                pay_all_total: room.finalPrice,
                memo: data.memo,
                pay_method: data.payMethod,
                daehaeng: 1,
                couponDiscount: room.couponDiscount,
                couponName: room.couponName,
                coupon_idx: room.coupon_idx,
            };
            (paymentServerDataArray as Array<PaymentBookingServerProps>).push(paymentServerData);
        });
    } else {
        // 무통장
        selectRoomList.forEach((room) => {
            const paymentServerData: PaymentBookingServerProps = {
                co_id: defaultParams.co_id,
                idx: Number(defaultParams.idx),
                room_num: Number(room.roomIdx),
                or_name: data.buyer,
                checkin: room.date.split("(")[0],
                period: room.dayNight,
                tel: data.phoneNumber,
                adult: Number(room.roomDetailInfo.personOfCapacity.min) + Number(room.addPeople.adult),
                children: Number(room.addPeople.child) + Number(room.addPeople.infant),
                pay_basic: room.discountPrice,
                pay_all_total: room.finalPrice,
                memo: data.memo,
                pay_method: data.bank,
                daehaeng: 0,
                couponDiscount: room.couponDiscount,
                couponName: room.couponName,
                coupon_idx: room.coupon_idx,
            };
            (paymentServerDataArray as Array<PaymentBookingServerProps>).push(paymentServerData);
        });
    }

    if (selectRoomList.length === 1) {
        // 길이가 1일 경우 단일 객체로 변경
        paymentServerDataArray = (paymentServerDataArray as PaymentBookingServerProps[])[0];
    }

    const totalPayPrice = Array.isArray(paymentServerDataArray)
        ? paymentServerDataArray.reduce((acc, item) => acc + item.pay_all_total, 0) -
          paymentServerDataArray.reduce((acc, item) => acc + item.couponDiscount, 0)
        : paymentServerDataArray.pay_all_total - paymentServerDataArray.couponDiscount;

    return { paymentServerDataArray, totalPayPrice };
};
